import { Colors, Spacing } from 'core/CssVariables';
import styled from 'styled-components';
import { TUploadColor } from './Uploader.type';

export const UploaderWrapper = styled.div<{color?: TUploadColor}>`
  && {
    text-align: center;
    padding: ${Spacing.SpacingLG}px;
    position: relative;
    cursor: pointer;
    border: 1px dashed ${Colors.PrimaryColor};
    background-color: ${({color}) => color === 'white' ? Colors.White : Colors.BackgroundColor};
    border-radius: 8px;
  }
`;
